import { useEffect } from 'react';
import { palette, fontFamily } from '../../styles/tokens';

export function ConnectRefreshPage() {
  useEffect(() => {
    document.title = 'Redirecting — CrewBit';
    window.location.replace('/today');
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: palette.bg, fontFamily,
    }}>
      <div style={{ textAlign: 'center', color: palette.g500, fontSize: 14 }}>
        <div
          aria-hidden="true"
          style={{
            width: 24, height: 24, margin: '0 auto 12px',
            border: `2px solid ${palette.g200}`, borderTopColor: palette.accent,
            borderRadius: '50%', animation: 'connectRefreshSpin 0.8s linear infinite',
          }}
        />
        Redirecting...
      </div>
      <style>{'@keyframes connectRefreshSpin { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}
